import { combineReducers } from 'redux'

import loading from './reducers/loading'
import adminReducer from './reducers/admin/adminSlice'
import webConfigReducer from './reducers/webconfig/webConfigSlice'
import { webConfigApi } from './services/webConfigApi'

export default combineReducers({
  [webConfigApi.reducerPath]: webConfigApi.reducer,
  loading,
  admin: adminReducer,
  webConfig: webConfigReducer,
})
